/**
 * Retrieves a named part of the state, and returns an object holding that part of the state 
 * with the name of targetProperty or name when targetProperty is not defined
 * @param {string} name Refers to the name in the state, ie: products, busyState
 * @param {string?} targetProperty Refers to the name that should be returned, it is optional, and defaults to name
 */
export const namedStateMapProvider = (name, targetProperty) => state => ({ [targetProperty || name]: state[name] });